import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {LEADS_TAB, Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import {User} from '@models/user';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {Title} from '@angular/platform-browser';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {ShareComponent} from '@components/popup/share/share.component';
import {TrackingService} from '@services/tracking.service';
import {DuplicateComponent} from '@module/favorites/popup/duplicate/duplicate.component';
import * as $ from 'jquery';
import {OnboardingService} from '@services/onboarding.service';
import {AlertService} from '@services/alert.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {UserService} from '@services/user.service';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {RenameComponent} from '@module/favorites/popup/rename/rename.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {AiAnalysisComponent} from '@module/favorites/popup/ai-analysis/ai-analysis.component';
import {PublishComponent} from '@module/favorites/popup/publish/publish.component';

@Component({
    selector: 'app-detail-wrap',
    templateUrl: './detail-wrap.component.html',
    styleUrls: ['./detail-wrap.component.scss']
})
export class DetailWrapComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tabs: Tab[] = [];
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    params;
    user: User = Object.assign({}, EMPTY_USER);
    link = window.location.toString();
    tuto = '';
    // Liste et page des favoris d'où l'on vient (le retour les restaure)
    returnPage = null;
    returnList = null;

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        public adService: AdService,
        private onboardingService: OnboardingService,
        private router: Router,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
        private titleService: Title,
        public userService: UserService,
        public trackingService: TrackingService,
    ) {
    }

    ngOnInit() {
        this.findTuto();
        this.route.queryParams.subscribe(params => {
            // undefined (et non null) quand absent : le queryParam du lien retour est alors omis
            this.returnPage = params.returnPage;
            this.returnList = params.returnList;
        });
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.link = val.urlAfterRedirects.toString();
                this.findTuto();
            }
        });

        this.route.data.subscribe(data => {
            this.tabs = [];
            data.tabs.forEach(tab => {
                this.tabs.push(Object.assign({}, tab));
            });
        });

        if (!this.authenticationService.isAllowed('basique') && this.dialog.openDialogs.length === 0) {
            this.trackingService.click('favorite_detail_plan', '');
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    disableClose: true,
                    data: {visuel: 'assets/upgrade/simulation.png', plan: 'Basique', feature: 'Simulateur d\'investissement', disableClose: true},
                });
            }
        }

        this.route.params.subscribe(params => {
            this.params = params;

            this.adService.getFavorite(params.favoriteId).subscribe(result => {
                if (result.title == 'redirect') {
                    this.router.navigate(['/app/annonces/share', result.public_id]);
                    return;
                }

                this.favorite = this.adService.updateValues(result);
                this.refreshLeadsTab();

                this.titleService.setTitle('LyBox -  ' + this.favorite.favorite_list.title + ' - ' + this.favorite.title);
                this.adService.cacheFavorite(this.favorite);
                if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.pdf.status == 'not_started') {
                    this.onboardingService.startPDF(params.id, params.favoriteId).subscribe();
                }
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable');
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });
        });

        this.user = this.authenticationService.currentUser;
    }

    findTuto() {
        if (this.link.includes('/annonce')) {
            this.tuto = 'annonce';
        } else if (this.link.includes('/ville')) {
            this.tuto = 'ville';
        } else if (this.link.includes('/inout')) {
            this.tuto = 'rendement';
        } else if (this.link.includes('/impot')) {
            this.tuto = 'impot';
        } else {
            this.tuto = '';
        }
    }

    deleteFavorite(): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '480px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer ce favoris et perdre toutes les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(this.favorite).subscribe(r => {
                    this.router.navigate(['/app/favorites', this.favorite.favorite_list.id]);
                });
            }
        });
    }

    moveFavorite(): void {
        const dialogRef = this.dialog.open(AddComponent, {
            width: '480px',
            data: {favorite: this.favorite, mode: 'move'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.router.navigate(['/app/favorites', result[0], this.favorite.id]);
            }
        });
    }

    renameFavorite(): void {
        const dialogRef = this.dialog.open(RenameComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite = result;
                this.adService.updateCacheFavorite(this.favorite);
            }
        });
    }

    // Onglet Leads affiché : pas de personnalisation de page (aucune route d'édition)
    get isLeadsTab(): boolean {
        return this.link.includes('/' + LEADS_TAB.slug);
    }

    // Onglet « Leads » après « Mon dashboard » : compte publieur et favori publié ou déjà publié
    // (dépublié : les leads reçus restent consultables)
    refreshLeadsTab(): void {
        const index = this.tabs.findIndex(t => t.slug === LEADS_TAB.slug);
        const show = this.authenticationService.canPublishFavorite
            && (this.adService.isPublished(this.favorite) || this.adService.isUnpublished(this.favorite));
        // Avec l'onglet Leads, « Mon dashboard » devient « Dashboard » (place pour 7 onglets)
        const dashboard = this.tabs.find(t => t.slug === 'dashboard');
        if (dashboard) {
            dashboard.title = show ? 'Dashboard' : 'Mon dashboard';
        }
        if (show && index === -1) {
            this.tabs = this.tabs.concat([Object.assign({}, LEADS_TAB)]);
        } else if (!show && index !== -1) {
            this.tabs = this.tabs.filter(t => t.slug !== LEADS_TAB.slug);
            if (this.link.includes('/' + LEADS_TAB.slug)) {
                this.router.navigate(['/app/favorites', this.favorite.favorite_list.id, this.favorite.id]);
            }
        }
    }

    // Publication partenaire sur le moteur de recherche (compte publieur)
    publishFavorite(): void {
        this.trackingService.click('favorite_publish', this.favorite.id);
        const dialogRef = this.dialog.open(PublishComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite = this.adService.updateValues(result);
                this.adService.updateCacheFavorite(this.favorite);
                this.refreshLeadsTab();
            }
        });
    }

    dupplicateFavorite(): void {
        const dialogRef = this.dialog.open(DuplicateComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.router.navigate(['/app/favorites', this.favorite.favorite_list.id, result.id]);
            }
        });
    }

    share(): void {
        const dialogRef = this.dialog.open(ShareComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    upgradePlan() {
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/dashboard.png', plan: 'Expert', feature: 'Dashboard personnalisé'}
            });
        }
    }

    compareAdd() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel: 'assets/upgrade/compare.png', plan: 'Essentiel', feature: 'Comparaison entre projets'}
                });
            }
        } else {
            this.adService.getCompareAd().subscribe(ads => {
                if (ads.length >= 5) {
                    this.alertService.error('Comparaison limitée à 5 projets, veuillez supprimer un projet dans la comparaison.');
                } else {
                    this.adService.addCompareAd(this.favorite.id);
                    this.router.navigate(['/app/favorites/compare']);
                }
            });
        }
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            maxWidth: '100%',
            data: {video: this.tuto}
        });
    }

    openAIAnalysis(): void {
        this.dialog.open(AiAnalysisComponent, {
            width: '780px',
            data: {favorite: this.favorite},
        });
    }

    // Tooltip du titre : uniquement quand le titre est réellement tronqué (ellipsis)
    adjustTitleTip(tip: {disabled: boolean}, e: Event) {
        const el = e.currentTarget as HTMLElement;
        const truncated = el.scrollWidth > el.clientWidth;
        tip.disabled = !truncated;
        // Neutralise le cursor:help global des triggers de tooltip quand le titre rentre en entier
        el.style.cursor = truncated ? 'help' : 'default';
    }

    showTitleTip(tip: {disabled: boolean, show: () => void}, e: Event) {
        this.adjustTitleTip(tip, e);
        if (!tip.disabled) {
            tip.show();
        }
    }
}
